/*global SPiD*/

SPiD.enableAddressAutoComplete = (function () {
    'use strict';
    function disableHiddenFields(form, fallback) {
        var disabled = SPiD.hasClass(fallback, 'hidden');
        SPiD.findElements(fallback, 'input, select, textarea').forEach(function (el) {
            el.disabled = disabled;
        });

        SPiD.findElements(form, 'input, select, textarea').forEach(function (el) {
            el.disabled = !disabled;
        });
    }

    return function (el) {

        if (el.length) {
            for (var i = 0, l = el.length; i < l; ++i) {
                SPiD.enableAddressAutoComplete(el[i]);
            }
            return;
        }

        var form = el.querySelector('.di-auto-complete');
        var fallback = el.querySelector('.di-fallback');

        var addressAutoComplete = new window.DI.widget.AddressAutoComplete(el.id, {
            serviceUrl: 'https://app.di.no/app/AutoCompleteServlet'
        });

        addressAutoComplete.selectionChangeEvent.subscribe(function () {
            var addr = addressAutoComplete.getSelectedAddress();
            var showAdditionalRow = addr.streetNumber !== null && addr.floor !== -1;
            var showHouseholdRow = showAdditionalRow && addr.floor !== null && addr.household !== -1;
            var showZipRow = addr.streetNumber && addr.streetNumber.postalCode;

            SPiD.toggle(form.querySelector('.di-floor-section'), showAdditionalRow);
            SPiD.toggle(form.querySelector('.di-apartment-section'), showHouseholdRow);
            SPiD.toggle(form.querySelector('.di-zip-section'), showZipRow);
            SPiD.toggle(form.querySelector('.di-country-section'), showZipRow);

            SPiD.val(form, '.di-street', addr.street && addr.street.streetName);
            SPiD.val(form, '.di-streetno', addr.streetNumber && addr.streetNumber.streetNo);
            SPiD.val(form, '.di-locality', addr.street && addr.street.city);
            SPiD.val(form, '.di-zipcode', addr.streetNumber && addr.streetNumber.postalCode);
            SPiD.val(form, '.di-entrance', addr.streetNumber && addr.streetNumber.entrance);
            SPiD.val(form, '.di-floor', addr.floor && addr.floor.floorNo);

            if (addr.household && addr.floor && addr.household.flatType !== -1) {
                SPiD.val(form, '.di-apartment', addr.floor.floorType +
                         SPiD.zeroPad(addr.floor.floorNo) +
                         SPiD.zeroPad(addr.household.flatNo));
            }
        });

        el.querySelector('.di-toggle-forms').addEventListener('click', function (e) {
            e.preventDefault();
            var text = this.innerHTML;
            this.innerHTML = this.getAttribute('data-text');
            this.setAttribute('data-text', text);
            SPiD.toggle(fallback);
            SPiD.toggle(form);

            disableHiddenFields(form, fallback);
        });

        disableHiddenFields(form, fallback);
    };
}());
